export default __webpack_public_path__ + "static/media/privilege-gift-yellow.6c6d3feb.svg";